// Import functions and modules
import { isMobile, getHash, menuClose } from "../functions.js";
import { flsModules } from "../../files/modules.js";
import { gotoBlock } from "./gotoblock.js";

// Control variable for adding window scroll event
let addWindowScrollEvent = false;

// Smooth navigation across the page
export function pageNavigation() {
    document.addEventListener("click", pageNavigationAction);
    document.addEventListener("watcherCallback", pageNavigationAction);

    function pageNavigationAction(e) {
        if (e.type === "click") {
            const targetElement = e.target;
            if (targetElement.closest('[data-goto]')) {
                const gotoLink = targetElement.closest('[data-goto]');
                const gotoLinkSelector = gotoLink.dataset.goto || '';
                const noHeader = gotoLink.hasAttribute('data-goto-header');
                const gotoSpeed = gotoLink.dataset.gotoSpeed || 500;
                const offsetTop = parseInt(gotoLink.dataset.gotoTop) || 0;

                if (flsModules.fullpage) {
                    const fullpageSection = document.querySelector(`${gotoLinkSelector}`).closest('[data-fp-section]');
                    const fullpageSectionId = fullpageSection ? +fullpageSection.dataset.fpId : null;
                    if (fullpageSectionId !== null) {
                        flsModules.fullpage.switchingSection(fullpageSectionId);
                        if (document.documentElement.classList.contains("menu-open")) menuClose();
                    }
                } else {
                    gotoBlock(gotoLinkSelector, noHeader, gotoSpeed, offsetTop);
                }
                e.preventDefault();
            }
        } else if (e.type === "watcherCallback" && e.detail) {
            const entry = e.detail.entry;
            const targetElement = entry.target;
            if (targetElement.dataset.watch === 'navigator') {
                const navigatorActiveItem = document.querySelector(`[data-goto]._navigator-active`);
                let navigatorCurrentItem;
                if (targetElement.id && document.querySelector(`[data-goto="#${targetElement.id}"]`)) {
                    navigatorCurrentItem = document.querySelector(`[data-goto="#${targetElement.id}"]`);
                } else if (targetElement.classList.length) {
                    targetElement.classList.forEach(cls => {
                        if (!navigatorCurrentItem && document.querySelector(`[data-goto=".${cls}"]`)) {
                            navigatorCurrentItem = document.querySelector(`[data-goto=".${cls}"]`);
                        }
                    });
                }
                if (entry.isIntersecting) {
                    navigatorCurrentItem?.classList.add('_navigator-active');
                } else {
                    navigatorCurrentItem?.classList.remove('_navigator-active');
                }
            }
        }
    }

    if (getHash()) {
        const goToHash = document.querySelector(`#${getHash()}`) ? `#${getHash()}` : `.${getHash()}`;
        if (goToHash) gotoBlock(goToHash, true, 500, 20);
    }
}

// Header scroll behavior
export function headerScroll() {
    addWindowScrollEvent = true;
    const header = document.querySelector('header.header');
    const headerShow = header.hasAttribute('data-scroll-show');
    const headerShowTimer = header.dataset.scrollShow || 500;
    const startPoint = header.dataset.scroll || 1;
    let scrollDirection = 0;
    let timer;

    document.addEventListener("windowScroll", () => {
        const scrollTop = window.scrollY;
        clearTimeout(timer);

        if (scrollTop >= startPoint) {
            header.classList.add('_header-scroll');
            if (headerShow) {
                if (scrollTop > scrollDirection) {
                    header.classList.remove('_header-show');
                } else {
                    header.classList.add('_header-show');
                }
                timer = setTimeout(() => header.classList.add('_header-show'), headerShowTimer);
            }
        } else {
            header.classList.remove('_header-scroll');
            headerShow && header.classList.remove('_header-show');
        }
        scrollDirection = Math.max(scrollTop, 0);
    });
}

// Add padding to main content for sticky header
export function paddingToMain() {
    const header = document.querySelector('.header');
    const main = document.querySelector('.main');
    main.style.paddingTop = `${header.clientHeight}px`;
}

// Simple fixed header behavior
export function headerScrollFixed() {
    window.addEventListener("scroll", () => {
        const header = document.querySelector('.header');
        if (window.scrollY >= 300) {
            header.classList.add("_header-scroll");
        } else {
            header.classList.remove("_header-scroll");
        }
        if (window.scrollY >= 500) {
            header.classList.add("_header-show");
        } else {
            header.classList.remove("_header-show");
        }
    });
}

// Counter animation for digits
export function digitsCounter() {
    if (document.querySelectorAll("[data-digits-counter]").length) {
        document.querySelectorAll("[data-digits-counter]").forEach(element => {
            element.dataset.digitsCounter = element.innerHTML;
            element.innerHTML = '0';
        });
    }

    function digitsCountersInit(digitsCountersItems) {
        const digitsCounters = digitsCountersItems || document.querySelectorAll("[data-digits-counter]");
        digitsCounters.forEach(digitsCounter => digitsCountersAnimate(digitsCounter));
    }

    function digitsCountersAnimate(digitsCounter) {
        let startTimestamp = null;
        const duration = parseInt(digitsCounter.dataset.digitsCounterSpeed) || 1000;
        const startValue = parseInt(digitsCounter.dataset.digitsCounter);
        const startPosition = 0;

        function step(timestamp) {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            digitsCounter.innerHTML = Math.floor(progress * (startPosition + startValue));
            if (progress < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
    }

    function digitsCounterAction(e) {
        const entry = e.detail.entry;
        const targetElement = entry.target;
        if (targetElement.querySelectorAll("[data-digits-counter]").length) {
            digitsCountersInit(targetElement.querySelectorAll("[data-digits-counter]"));
        }
    }

    document.addEventListener("watcherCallback", digitsCounterAction);
}

// Automatically attach scroll event if needed
setTimeout(() => {
    if (addWindowScrollEvent) {
        const windowScroll = new Event("windowScroll");
        window.addEventListener("scroll", () => document.dispatchEvent(windowScroll));
    }
}, 0);
